import { SuccessCompassDataService } from './../../Services/success-campass.service';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Milestone, UserTaskNotificationVO } from 'app/models/psp-notification';
import { AppSettings } from 'app/app-settings';


@Component({
  selector: 'app-activity-psp-info-no-plan',
  templateUrl: './activity-psp-info-no-plan.component.html',
  styleUrls: ['./activity-psp-info-no-plan.component.css']
})

export class ActivityPspInfoNoPlanComponent implements OnChanges{
  @Input() data: UserTaskNotificationVO = null;
  buttonName: string = '';
  pointText: string = '';
  heading: string = '';

  constructor(){}

  ngOnChanges(changes: SimpleChanges): void {
    this.modifyData();
  }
  modifyData() {
    if(this.data){
      switch(this.data.executionState){
        case 'COMPLETE':
          this.pointText = 'Great! You have a study plan in place, let`s execute it!';
          this.buttonName = 'Execute Study Plan';
          this.heading = 'Execute Your Study Plan';
          break;
        case 'PLAN_EXECUTION_COMPLETED':
          this.pointText = 'Great work! You made a plan, executed it. It is now time to take the test. Good luck!';
          this.buttonName = 'View Study Plan';
          this.heading = 'Congratulations! You are ready to take the GMAT!';
          break;
        case 'NOT_SEEN':
        case 'INCOMPLETE':
          this.pointText = 'You currently do not have a study plan in place. We suggest that you make one.';
          this.buttonName = 'Create Study Plan';
          this.heading = 'No Study Plan Created';
          break;
      }
    }
  }

  goToStudyPlan(){
    window.open(AppSettings.gfePSPUrl, '_blank');
  }
}
